import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import { setStates } from 'Store/Organization/States/StatesAction';
import { GET_STATES } from 'Store/Organization/States/StatesType';
import { apiMethod, apiType, API_URL } from 'utils';
import OrganizationApiService from './OrganizationApiService';
import { IPayload } from 'Model/IPayload';

function* getStates(): any {

    let payloadData : IPayload = {                
        apiMethod : apiMethod.GET,
        apiType : apiType.Organization,
        endpoint : `organizations/dropdown/states`,   
        payload : null    
    }
    try {
        yield put(globalLoaderText("Fetching Data...."));
        const response = yield call(
            OrganizationApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setStates(response));
        yield put(globalLoaderText(""));
    } catch (error) {
        console.log(error);
        yield put(globalLoaderText(""));
    }
}

function* watchGetStates() {
    yield takeEvery(GET_STATES, getStates)
}

export default function* combinedSaga() {
    yield all([
        watchGetStates()
    ])
}
